import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-dialog-header-with-help',
  templateUrl: './dialog-header-with-help.component.html',
  styleUrls: ['./dialog-header-with-help.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DialogHeaderWithHelpComponent {
  @Input() title: string
  @Input() helpUrl?: string
}
